import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

import {
  reducerGetGoods,
  reducerGoodsStatus
} from "../../reducer/tunder/reducers/reducerGoods";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionImportProducts =
  (files?: File[]) => async (dispatch: AppDispatch) => {
    const {token} = await getToken();
    const headers = {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    };
    
    const formData = new FormData();
    
    files && files.forEach((file: File) => {
      formData.append("excelFile", file, file.name);
    });
    
    try {
      const response = await axios.put(
        `${BASE_URL}/json/tander/importProducts`,
        formData,
        {
          headers: headers,
        }
      );
      
      dispatch(reducerGoodsStatus(response.status));
      
    } catch (err) {
      dispatch(reducerGoodsStatus(0));
    }
  };

export const actionGetProductsOsa =
  (limit: number, offset: number) => async (dispatch: AppDispatch) => {
    const {token} = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    
    try {
      const response = await axios.get(
        `${BASE_URL}/json/tander/products?offset=${offset}&limit=${limit}`
      );
      
      dispatch(reducerGetGoods(response.data));
    } catch (err) {
      dispatch(reducerGoodsStatus(400));
    }
  };

export const actionExportTanderProducts = () => async (dispatch: AppDispatch) => {
  try {
    const {token} = await getToken();
    const headers = {
      Authorization: token,
    };
    await axios.get(
      `${BASE_URL}/json/tander/exportProducts`,
      {headers}
    );
    
    dispatch(reducerGoodsStatus(205));
  } catch (error) {
    dispatch(reducerGoodsStatus(0));
  }
};
